import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { quotationFormDefault } from "@factory/form/form.default";
import {
  QuotationFormRule,
  QuotationFormSchema,
} from "@factory/form/form.rule";
import { useQyCreateQuotation } from "@factory/query/quotation.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewQuotation() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateQuotation } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Quotation is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addQuotation, isLoading: isCreating } =
    useQyCreateQuotation(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<QuotationFormSchema>({
    defaultValues: {
      ...quotationFormDefault,
      quotationDate: new Date().toISOString(),
    },
    resolver: zodResolver(QuotationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: QuotationFormSchema) => {
    const formData = mapCreateQuotation(form);
    addQuotation(formData);
  };
  const handleValidateError = (err: FieldErrors<QuotationFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
